(function () {
  function getSoldOutText() {
    return window.meamaTranslations?.soldOut || window.theme?.variantStrings?.soldOut || '';
  }

  function applyOutOfStock() {
    const MAP = window.meamaOutOfStock?.products;
    if (!MAP) return;

    document.querySelectorAll('.product-card').forEach(card => {
      if (card.dataset.meamaApplied) return;
      card.dataset.meamaApplied = '1';

      const form = card.querySelector('form[is="product-form"]');
      if (!form) return;

      const productIdInput = form.querySelector('input[name="product-id"]');
      if (!productIdInput) return;

      const productId = productIdInput.value;
      if (!MAP[productId]) return;

      const button = form.querySelector('button[type="submit"]');
      if (!button) return;

      // Disable button
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');

      // Replace text
      const text =
        button.querySelector('.btn-text span.hidden.md\\:block') ||
        button.querySelector('.btn-text span') ||
        button.querySelector('.btn-text');

      const soldOutText = getSoldOutText();
      if (text && soldOutText) {
        text.textContent = soldOutText;
      }

      // Visual downgrade
      button.classList.remove('button--primary');
      button.classList.add('button--secondary');
    });
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyOutOfStock);
  } else {
    applyOutOfStock();
  }

  // Re-run on dynamic loads (filters, pagination, infinite scroll)
  const observer = new MutationObserver(applyOutOfStock);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
